module.exports = __webpack_public_path__ + "static/media/azdararir.de3b6292.gif";